import React from 'react';
import {createRoot} from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import theme from './theme'
import {  ThemeProvider} from '@mui/material/styles';
import { store} from './redux/store';
import { Provider } from 'react-redux';

const queryClient = new QueryClient();

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

root.render(
  <ThemeProvider theme={theme}>
  <BrowserRouter>
  <QueryClientProvider client={queryClient}>
  <Provider store={store}>
    <App />
    </Provider>
    </QueryClientProvider>
  </BrowserRouter>
  </ThemeProvider>
);

